<template>
  <div class="content">
    <SummaryIntroSection/>
    <SummaryChecklistSection/>
      
  </div>
</template>

<script lang="ts">
import SummaryIntroSection from '@/components/VerbalIdentityPage/sections/summary/SummaryIntroSection.vue'
import SummaryChecklistSection from '@/components/VerbalIdentityPage/sections/summary/SummaryChecklistSection.vue'
import { Component, Vue } from 'vue-property-decorator'


@Component({
  components: {
    SummaryIntroSection,
    SummaryChecklistSection
  }
})
export default class SummaryView extends Vue {}
</script>

<style lang="scss"></style>
